// extracted by mini-css-extract-plugin
export default {"commonCard":"styles_commonCard__KkJU5","divider":"styles_divider__GMgTG","badge":"styles_badge__k44z5","blur":"styles_blur__X0yX8","absoluteAlert":"styles_absoluteAlert__Ef-+g"};